export default __webpack_public_path__ + "static/itinfrastructureintegration-a1be9fd3fb2f4623c5fa68f986937a07.svg";